import { getMinDeductibleTravelExpenses } from "../carUsage/utils";
import { validateAmounts } from "../utils";
import {
  EuerDeclarationTravelExpensesSubformInputs,
  EuerDeclarationTravelExpensesSubformCalculationResults,
} from "./types";

const PRIVATE_CAR_USAGE_RATE_IN_CENTS = 30;

export const calculateTravelExpensesSubformResults = (
  inputs: EuerDeclarationTravelExpensesSubformInputs,
  declarationYear: number
): EuerDeclarationTravelExpensesSubformCalculationResults => {
  if (declarationYear < 2019) {
    throw new Error("Invalid declaration year");
  }

  validateAmounts(Object.values(inputs));

  const {
    commuteDistance,
    commuteDays,
    privateCarTravelDistance,
    additionalMealExpenses,
  } = inputs;

  const privateCarUsageContribution =
    privateCarTravelDistance * PRIVATE_CAR_USAGE_RATE_IN_CENTS;

  const minDeductibleTravelExpenses = getMinDeductibleTravelExpenses({
    commuteDays,
    commuteDistance,
    declarationYear,
  });

  const profitReduction =
    privateCarUsageContribution +
    additionalMealExpenses +
    minDeductibleTravelExpenses;

  return {
    privateCarUsageContribution,
    additionalMealExpenses,
    minDeductibleTravelExpenses,
    profitReduction,
  };
};
